import {
  WeatherFog,
  WeatherPartlyCloudy,
  WeatherRain,
  WeatherSnow,
  WeatherSunny,
  WeatherThunder,
} from "@/components/icon/svg"

/**
 * WMO weather code (https://open-meteo.com/en/docs) → 아이콘 매핑.
 * 그룹:
 *  0       Clear sky                → Sunny
 *  1-3     Mainly clear ~ overcast  → Partly cloudy
 *  45, 48  Fog                      → Fog
 *  51-67   Drizzle/Rain             → Rain
 *  71-77   Snow                     → Snow
 *  80-82   Rain showers             → Rain
 *  85, 86  Snow showers             → Snow
 *  95-99   Thunderstorm             → Thunder
 */
export function weatherIconFromCode(code: number | null | undefined, size = 16) {
  if (code === null || code === undefined) return null

  if (code === 0) return <WeatherSunny width={size} height={size} />
  if (code >= 1 && code <= 3) return <WeatherPartlyCloudy width={size} height={size} />
  if (code === 45 || code === 48) return <WeatherFog width={size} height={size} />
  if ((code >= 51 && code <= 67) || (code >= 80 && code <= 82))
    return <WeatherRain width={size} height={size} />
  if ((code >= 71 && code <= 77) || code === 85 || code === 86)
    return <WeatherSnow width={size} height={size} />
  if (code >= 95 && code <= 99) return <WeatherThunder width={size} height={size} />

  return <WeatherPartlyCloudy width={size} height={size} />
}
